import { CTA } from "@/constants/testIds";
import { goToShwcare } from "@/lib/shwcareHandoff";

export default function FinalCTA() {
  return (
    <section
      id="start-assessment"
      data-testid={CTA.section}
      className="relative overflow-hidden bg-gradient-pb"
    >
      <div className="px-5 md:px-8 lg:px-12 py-12 md:py-16 max-w-[1500px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7">
            <h2 className="font-display text-[36px] sm:text-[48px] md:text-[58px] lg:text-[68px] leading-[0.92] text-white tracking-tight">
              YOUR NEXT CHAPTER<br />
              STARTS HERE.
            </h2>
          </div>
          <div className="lg:col-span-5 flex flex-col md:flex-row items-start md:items-center gap-5 lg:justify-end">
            <p className="font-body italic text-[14px] md:text-[15px] text-white/90 max-w-xs">
              It all starts with a simple assessment.
            </p>
            <a
              href="#start-assessment"
              data-testid={CTA.startAssessment}
              className="btn-light shrink-0"
            >
              Start Your Assessment <span aria-hidden>→</span>
            </a>
            <button
              type="button"
              onClick={() => goToShwcare("", { campaign: "bestrx_final_cta" })}
              data-testid="final-cta-shwcare-handoff"
              className="shrink-0 text-[12px] font-semibold text-white/80 underline underline-offset-4 hover:text-white transition-colors"
            >
              Already know what you need? Continue to SHWCare care →
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
